// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.jmIiR_YTm2AdrFvl{border-radius:1000px}.mcRCBSZsOW0_RYol{white-space:nowrap;overflow:hidden;text-overflow:ellipsis;display:block}.j51UvVqm9O4E6dHf{display:flex;flex-direction:column;justify-content:center;align-items:center}.tZkTmiPJwAHfBOsr{animation:aRoL8UccwcEitANy 3s infinite;animation-iteration-count:infinite}@keyframes aRoL8UccwcEitANy{0%{background:var(--py-neutral-1)}30%{background:var(--py-neutral-1)}50%{background:var(--py-neutral-1)}80%{background:var(--py-neutral-1)}100%{background:var(--py-neutral-1)}}.T196zfEoelIagdfS{width:100%;height:1px;background-color:var(--py-neutral-2);border:none}.Os0du6qLww8WDfuR{width:1px;height:auto;align-self:stretch}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"circle": `jmIiR_YTm2AdrFvl`,
	"text-truncate": `mcRCBSZsOW0_RYol`,
	"shaquille": `j51UvVqm9O4E6dHf`,
	"shimmer": `tZkTmiPJwAHfBOsr`,
	"placeHolderShimmer": `aRoL8UccwcEitANy`,
	"divider": `T196zfEoelIagdfS`,
	"vertical": `Os0du6qLww8WDfuR`
};
export default ___CSS_LOADER_EXPORT___;
